import * as React from 'react'
import { StyledIcon, StyledBlock } from '$views/components/AppMenu/AppMenu.style'
import { Text } from '$views/components'
import { Block } from '$views/components/Layout/Block'
import { Circle } from '$views/components/Circle'

interface Props {
  content: string
  onClick: () => void
  label: string
  isEnable: boolean
  circle?: boolean
}

export const AppMenuIcon: React.FC<Props> = ({ content, onClick, label, isEnable, circle }) => {
  return (
    <StyledBlock onClick={onClick}>
      <Block flex justify="center">
        {circle && <Circle />}
        <StyledIcon content={content} />
      </Block>
      <Text tiny color={isEnable ? 'darkGrey' : 'menu'} weight={isEnable ? 'bold' : 'regular'} marginTop="tiny">
        {label}
      </Text>
    </StyledBlock>
  )
}



// WEBPACK FOOTER //
// ./src/views/components/AppMenu/components/AppMenuIcon.tsx